// extracted by mini-css-extract-plugin
module.exports = {"buttons":"booleanButtons_buttons__2eyfH","not":"booleanButtons_not__QOXwn"};